import React from 'react';

import { Text, TEXT_VARIANTS } from 'ui/Typography';

const WrittenResponseRepeatableQuestion = props => {
  const { isDisabled, draft, setDraft, meta, setFinishedWriting } = props;
  const { previewing = false } = meta;

  const handleChange = e => {
    e.preventDefault();
    if (draft === '') {
      setFinishedWriting(false);
    }
    setDraft(e.target.value);
  };
  return (
    <div className="pl-32 pr-32">
      <Text className="mt-0" variant={TEXT_VARIANTS.BODY_BOLD}>
        {t('questions.question.written_response.instructions')}
      </Text>
      <textarea
        data-test-id="reply-container-textarea"
        className="ReplyContainer-input h-100 pl-12 mt-16 p-8 bdrs-2 w-fill bg-gray-lightest border border-gray-light"
        disabled={isDisabled}
        onChange={e => handleChange(e)}
        value={previewing ? '' : draft}
      />
    </div>
  );
};

export default WrittenResponseRepeatableQuestion;
